import axios from 'axios';
import { AppSettings } from '../../configs';
import { authHeader } from '../../helpers/auth-header';

import {
    MODAL_EMPLOYEE_KEY_VALUE,
    MODAL_EMPLOYEE_INPUT_EMPCODE,
    MODAL_EMPLOYEE_INPUT_EMPNAME,
    MODAL_EMPLOYEE_INPUT_POSITION,
    MODAL_EMPLOYEE_INPUT_POSITIONABBR,
    MODAL_EMPLOYEE_INPUT_DEPARTMENTCODE,
    MODAL_EMPLOYEE_INPUT_DEPARTMENTNAME,
    MODAL_EMPLOYEE_INPUT_DEPARTMENTABBR
} 
from './actionTypes';

export function setKeyValueAction(table, empCode, empName) {
  
    return function (dispatch) {

        dispatch({
            type: MODAL_EMPLOYEE_KEY_VALUE,
            table: table,
            empCode: empCode,
            empName: empName
        })

    }
}

export function setInputAction(input_name, input_value) {
  
    return function (dispatch) {

        if(input_name == "q_empCode"){
            dispatch({
                type: MODAL_EMPLOYEE_INPUT_EMPCODE,
                value: input_value
            })
    
        }else if(input_name == "q_empName"){
            dispatch({
                type: MODAL_EMPLOYEE_INPUT_EMPNAME,
                value: input_value
            })
        }else if(input_name == "q_position"){
            dispatch({
                type: MODAL_EMPLOYEE_INPUT_POSITION,
                value: input_value
            })
        }else if(input_name == "q_positionabbr"){
            dispatch({
                type: MODAL_EMPLOYEE_INPUT_POSITIONABBR,
                value: input_value
            })
        }else if(input_name == "q_departmentCode"){
            dispatch({
                type: MODAL_EMPLOYEE_INPUT_DEPARTMENTCODE,
                value: input_value
            })
        }else if(input_name == "q_departmentName"){
            dispatch({
                type: MODAL_EMPLOYEE_INPUT_DEPARTMENTNAME,
                value: input_value
            })
        }else if(input_name == "q_departmentABBR"){
            dispatch({
                type: MODAL_EMPLOYEE_INPUT_DEPARTMENTABBR,
                value: input_value
            })
        }else{

        }
       
    }
}


export function clearModalAction() {
  
    return function (dispatch) {

        dispatch({
            type: MODAL_EMPLOYEE_KEY_VALUE,
            table: null,
            empCode: null,
            empName: null
        })

        dispatch({
            type: MODAL_EMPLOYEE_INPUT_EMPCODE,
            value: null
        })

        dispatch({
            type: MODAL_EMPLOYEE_INPUT_EMPNAME,
            value: null
        })

        dispatch({
            type: MODAL_EMPLOYEE_INPUT_POSITION,
            value: null
        })

        dispatch({
            type: MODAL_EMPLOYEE_INPUT_POSITIONABBR,
            value: null
        })
        dispatch({
            type: MODAL_EMPLOYEE_INPUT_DEPARTMENTCODE,
            value: null
        })

        dispatch({
            type: MODAL_EMPLOYEE_INPUT_DEPARTMENTNAME,
            value: null
        })

        dispatch({
            type: MODAL_EMPLOYEE_INPUT_DEPARTMENTABBR,
            value: null
        })
       
    }
}